function isExternalLink( url ){
    return url.startsWith('http')
}

export default isExternalLink;